module.exports = __webpack_public_path__ + "static/media/webdesign-services-img72.6844aa5e.jpg";